import { SingleSelect } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export const textTransformOptions = {
	none: 'None',
	uppercase: 'Uppercase',
	lowercase: 'Lowercase',
	capitalize: 'Capitalize',
};


export function TextTransform()
{
	return (
		<StyleFieldsRow>
			<TextTransformFields />
		</StyleFieldsRow>
	);
}


/* The transform on its own, for a caller that names the location itself - see ruleProperties(). */
export function TextTransformFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<SingleSelect field='transform' options={textTransformOptions} />
		</LabelOnLeftWrap>
	);
}
